import React from 'react';
import _CopyRight from './_CopyRight.scss'

class CopyRight extends React.Component {

  render() {
    return (
      <div className='copyright-container'>
        <p className='footer-description'>Đơn vị chủ quản: SỞ CÔNG THƯƠNG TỈNH KON TUM</p>
        <p className='footer-description'>Địa chỉ: số 494(123B cũ) - Trần Phú - TP Kon Tum - Tỉnh Kon Tum</p>
        <p className='footer-description'>ĐT: 0260.3862.060. Fax: 0260.3862.508. Email: <a href="mailto:(socongthuongkt@gmail.com)">socongthuongkt@gmail.com</a></p>
        <p className='footer-description'>Người đại diện: Huỳnh Thị Tuyết Nga - Phó Giám đốc Sở Công thương tỉnh Kon Tum</p>
        <p className='footer-description'>Quyết định thành lập số : 54/2015/QĐ-UBND</p>
        <p className='footer-description'>Ngày cấp: 28/12/2015 - Nơi cấp: Ủy Ban Nhân Dân tỉnh Kon Tum</p>
      </div>
    );
  }
}
export default CopyRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/CopyRight.jsx